module.exports = __webpack_public_path__ + "static/assets/b2b4ad5307e24c6627f2077478017981.mp3";